let generation = 0;

/**
 * Captures the request generation used to fence raw Price and Availability promises. Those
 * requests are not owned by TanStack Query and can outlive the page that started them.
 */
export function currentPnaRequestGeneration(): number {
  return generation;
}

/** Advances the endpoint-response boundary for a Sold-To Account transition. */
export function invalidatePnaRequestGeneration(): number {
  generation += 1;
  return generation;
}

export function isCurrentPnaRequestGeneration(requestGeneration: number): boolean {
  return requestGeneration === generation;
}
